import angular from 'angular';
import InterceptBankConnect from './interceptBankConnect';

export default angular
  .module('components.interceptBankConnect', [])
  .component('interceptBankConnect', InterceptBankConnect).name;
